import { render, staticRenderFns } from "./LabReadings.vue?vue&type=template&id=858644d8&scoped=true&"
import script from "./LabReadings.vue?vue&type=script&lang=js&"
export * from "./LabReadings.vue?vue&type=script&lang=js&"
import style0 from "./LabReadings.vue?vue&type=style&index=0&id=858644d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858644d8",
  null
  
)

export default component.exports